module.exports = __webpack_public_path__ + "static/media/default-user-icon-light.23ec1c09.svg";